import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import sortBy from "../../../../assets/AccountingModule/filter.svg";
import edit from "../../../../assets/AccountingModule/edit2.svg";
import view from "../../../../assets/AccountingModule/view.svg";
import deleteIcon from "../../../../assets/AccountingModule/delete.svg";
import dropDownBlack from "../../../../assets/AccountingModule/dropdown_black.svg";
import { formatDate } from "../../../../utils/DateFormat";
import styles from "./style";
import Modal from "../../../../components/Modal";
import CustomPagination from "../../../../components/CustomPagination";

const QuotesPage = ({ data = [], handleDelete, total, currentPage, setCurrentPage, rowsPerPage, setRowsPerPage }) => {
  const navigate = useNavigate();
  const [opens, setOpens] = useState(false);

  const handleNavigate = (item) => {
    navigate("/dashboard/editQuote", { state: { item } });
  };

  const handleNavigateView = (rowItem) => {
    navigate("/dashboard/viewQuote", { state: { rowItem } });
  };

  const handleDeleteItem = (deleteId) => {
    handleDelete(deleteId);
  };

  return (
    <>
      <Box px="20px" mt={2}>
        <Box sx={styles.header}>
          <Typography sx={styles.headerText}>All Quotes</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("new")}
            sx={styles.addButton}
          >
            Add New
          </Button>
        </Box>
      </Box>
      <Box sx={styles.container}>
        <Box sx={styles.filterSection}>
          <Box sx={styles.searchContainer}>
            <input
              type="text"
              placeholder="Search"
              style={styles.searchInput}
            />
          </Box>
          <Box sx={styles.sortByContainer}>
            <img src={sortBy} alt="sortBy" />
            <Typography sx={styles.sortByText}>Sort By</Typography>
          </Box>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell padding="checkbox">
                  <Checkbox sx={styles.checkbox}
                    checked={selectedRows.length === data.length}
                    onChange={handleSelectAll}
                  />
                </TableCell> */}
                <TableCell sx={styles.tableCell}>Date</TableCell>
                <TableCell sx={styles.tableCell}>Quotes Number</TableCell>
                <TableCell sx={styles.tableCell}>Reference Number</TableCell>
                <TableCell sx={styles.tableCell}>Customer Name</TableCell>
                <TableCell sx={styles.tableCell} align="center">
                  Status
                </TableCell>
                <TableCell sx={styles.tableCell}>Amount</TableCell>
                <TableCell sx={{ ...styles.tableCell, pl: 5 }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Typography variant="h6">No Data</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                data.map((row) => (
                  <TableRow key={row.id}>
                    {/* <TableCell padding="checkbox">
                    <Checkbox
                      sx={styles.checkbox}
                      checked={selectedRows.indexOf(row?._id) !== -1}
                      onChange={() => handleSelectRow(row?._id)}
                    />
                  </TableCell> */}
                    <TableCell sx={styles.tableCells}>
                      {formatDate(row?.quoteDate)}
                    </TableCell>
                    <TableCell
                      sx={{
                        ...styles.tableCells,
                        width: 200,
                        maxWidth: 240,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={row?.quoteNumber}
                    >
                      {row?.quoteNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        ...styles.tableCells,
                        width: 200,
                        maxWidth: 240,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      title={row?.referenceNumber}
                    >
                      {row?.referenceNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        ...styles.tableCells,
                        width: 150,
                        maxWidth: 180,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      title={row?.customerName}
                    >
                      {row?.customerName}
                    </TableCell>
                    <TableCell sx={styles.statusCell}>
                      <Typography sx={styles.statusChip}>
                        {row?.status}
                      </Typography>
                    </TableCell>
                    <TableCell sx={styles.tableCells}>
                      {row.grandTotal
                        ? `$${row.grandTotal.toLocaleString()}`
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", gap: 0.7 }}>
                        <IconButton
                          size="small"
                          onClick={() => handleNavigate(row)}
                        >
                          <img src={edit} alt="edit" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleNavigateView(row)}
                        >
                          <img src={view} alt="view" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => {
                            handleDeleteItem(row?._id);
                          }}
                        >
                          <img src={deleteIcon} alt="delete" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
          <CustomPagination
            pageCount={total}
            totalItems={total}
            page={currentPage}
            setPage={setCurrentPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        </TableContainer>
      </Box>

      <Modal
        open={opens}
        setOpen={setOpens}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Bank"}
        handleDelete={handleDeleteItem}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};

export default QuotesPage;
